<template>
  <div class="page">
    <div class="panel-info" style="padding-top: 0">
      <a-affix class="affix-title" :target="affixTarget">
        <div class="panel-info-title">
          <h2 :title="data.name" class="text-ellipsis text-no-wrap overflow-hidden text-bold v-mr-sm">{{ data.name }}</h2>
          <!-- <a-tag color="#e10" v-if="data.state === 0"></a-tag>
          <a-tag color="#e10" v-else-if="data.state === 1">项目审核中</a-tag>
          <a-tag color="#e10" v-else-if="data.state === 3">项目申报书</a-tag>
          <a-tag color="#e10" v-else-if="data.state === 4">签订协议中</a-tag>
          <a-tag color="#e10" v-else-if="data.state === 5">资助执行中</a-tag>
          <a-tag color="#e10" v-else-if="data.state === 6">结项中</a-tag>
          <a-tag color="#e10" v-else-if="data.state === 7">已结项</a-tag>
          <a-tag color="#666" v-else-if="data.state === -1">已终止</a-tag> -->
          <a-space class="v-ml-auto">
            <a-button type="default" icon="rollback" @click="$router.push('list')">返回我的项目</a-button>
          </a-space>
        </div>
      </a-affix>
      <a-divider />
      <div class="v-mx-auto" style="max-width: 1600px">
        <div class="v-pa-lg v-mt-lg">
          <a-steps progress-dot :current="currentStep" size="small">
            <a-step title="项目申请">
              <div slot="description" style="white-space: nowrap; font-size: 12px">
                <div>{{ data.applyTime }}</div>
              </div>
            </a-step>
            <a-step title="项目审核">
              <div slot="description" style="white-space: nowrap; font-size: 12px">
                <div>{{ data.reviewTime }}</div>
              </div>
            </a-step>
            <a-step title="筹款申请">
              <div slot="description" style="white-space: nowrap; font-size: 12px">
                <div>{{ data.hzInfo && data.hzInfo.raiseTime }}</div>
              </div>
            </a-step>
            <a-step title="筹款审核"></a-step>
            <a-step title="项目执行"></a-step>
            <a-step title="项目结项"></a-step>
            <a-step title="完成"></a-step>
          </a-steps>
        </div>
      </div>
    </div>
    <div class="v-px-md">
      <a-tabs type="card" v-model="tab">
        <a-tab-pane key="basic" tab="项目信息">
          <basic />
        </a-tab-pane>
        <a-tab-pane key="budget" tab="项目预算表">
          <budget />
        </a-tab-pane>
        <a-tab-pane key="raise" tab="筹款申请">
          <raise />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import { viewPrj } from '@/api/project/funded'
import Basic from './view/basic'
import Budget from './view/budget'
import Raise from './view/raise'

export default {
  name: 'FundedProjectView',
  components: {
    Basic,
    Budget,
    Raise,
  },
  data() {
    return {
      tab: 'raise',
      tabs: [],
      projectId: +this.$route.query.id,
      data: {},
      currentStep: 2,
    }
  },
  computed: {
    raiseTypes: vm => vm.$store.state.app.raiseTypes,
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.load()
      }
    },
    load() {
      let id = this.projectId
      viewPrj({ id, ext: false }).then(({ data }) => {
        if (data.success) {
          this.data = data.result
          this.currentStep = this.data.state
        }
      })
    },
  },
  created() {
    this.init()
  },
}
</script>
